import { createSlice } from '@reduxjs/toolkit';
import { clearCombinedToken as clearAccessToken } from './sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { clearEntitlements } from './sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
export const resetStoreSlice = createSlice({
    name: 'store',
    initialState: {},
    reducers: {
        reset: () => {
            clearAccessToken();
            clearEntitlements();
        },
    },
});
export const { reset } = resetStoreSlice.actions;
//# sourceMappingURL=resetStore.js.map